import { render, staticRenderFns } from "./MusicLink.vue?vue&type=template&id=045878e2&"
import script from "./MusicLink.vue?vue&type=script&lang=js&"
export * from "./MusicLink.vue?vue&type=script&lang=js&"
import style0 from "./MusicLink.vue?vue&type=style&index=0&id=045878e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports